import { EndUserPages } from '@aurora/shared-types/pages/enums';
import React from 'react';
import MessagePage from '../../../components/page/MessagePage/MessagePage';

/**
 * Occasion Message Page
 *
 * @author Aditi Agarwal
 */
const OccasionMessagePage: React.FC<React.PropsWithChildren<unknown>> = () => {
  return <MessagePage pageId={EndUserPages.OccasionMessagePage} />;
};
export default OccasionMessagePage;
